<template>
  <div class="container">
    <div class="content-wrapper">
      <div class="container-lg">
        <div class="page-title-nav row">
          <div class="col-2 col-lg-3">
            <router-link :to="`/sakha`" class="btn btn-outline-secondary btn-custom btn-back">
              <i class="fa-icon fa-regular fa-arrow-left me-0"></i><span class="d-none d-lg-block ms-2">ย้อนกลับ</span>
            </router-link>
          </div>
          <div class="col-8 col-lg-6">
            <h1 class="page-title">ลืมรหัสผ่าน</h1>
          </div>
          <div class="col-12 col-lg-3">
            <a href="#" class="btn btn-primary btn-custom d-none"><i
                class="fa-icon fa-regular fa-home"></i><span>button</span></a>
          </div>
        </div>
        <div class="row mb-12 justify-content-center">
          <div class="col">
            <div class="content-card mb-4">
              <div class="content-card mb-4">
                <div class="content-card-title">
                  <h6 class="font-weight-normal mb-0"><span class="badge  bg-label-success ">STEP 3 </span>
                    เปลี่ยนรหัสผ่าน
                  </h6>
                </div>
                <div class="content-card-body">
                  <div class="row">
                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-2 mb-2 d-flex align-items-center">
                        <b>ชื่อผู้ใช้งาน</b> <small> กรุณาเลือก</small>
                      </div>
                      <div class="col-12 col-sm-12 col-md-9 p-0 mb-2">
                        <div class="row p-0 m-0">
                          <div class="col-12 col-sm-12 col-md-9 p-0 mb-2">
                            <div class="row p-0 m-0">
                              <template v-for="(item, index) in UsernameList">
                                <div class="col-12 col-sm-12 col-md-4 col-lg-3 text-center" :key="index">
                                  <input type="radio" class="input-hidden" v-bind:value="item.profileId"
                                    :checked="profileSelect == item.profileID">
                                  <label for="usr1" class="bank-radio border border-dark rounded w-100 pt-1"
                                    @click="clickProcess(item.profileID)">
                                    <span class="badge badge-dark" style="font-size:14px;">ชื่อเข้าสู่ระบบ</span>
                                    <span>{{ item.profileName }}</span>
                                  </label>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-2 mb-2 d-flex align-items-center">
                      รหัสผ่านใหม่
                    </div>
                    <div class="col-12 col-sm-12 col-md-9 mb-2">
                      <!-- <input type="password" class="form-control" name="password" id="password_val"
                        placeholder="password" v-model="password" /> -->
                        <div class="form-password-toggle">
                        <div class="input-group input-group-sm input-group-merge">
                          <span class="input-group-text"><i class="fa-icon fa-regular fa-key"></i></span>
                          <input v-model="password" type="password" class="form-control" name="password" id="password_val"
                            placeholder="รหัสผ่าน" />
                        </div>
                      </div>
                      <span id="password_text"></span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-2 mb-2 d-flex align-items-center">
                      ยืนยันรหัสผ่านใหม่
                    </div>
                    <div class="col-12 col-sm-12 col-md-9 mb-2">
                      <div class="form-password-toggle">
                        <div class="input-group input-group-sm input-group-merge">
                          <span class="input-group-text"><i class="fa-icon fa-regular fa-key"></i></span>
                          <input v-model="password_confirm" type="password" class="form-control" name="repassword" id="repassword_val"
                            placeholder="ยืนยันรหัสผ่าน" />
                        </div>
                      </div>
                      <span id="repassword_text"></span>
                      <!-- <input type="password" class="form-control" name="repassword" id="repassword_val"
                        placeholder="กรอก password อีกครั้ง" v-model="password_confirm" />
                      <span id="repassword_text"></span> -->
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col">
                      <router-link to="/hotgame" tag="button" class="btn btn-dark btn-block">
                        <i class="fa-icon fa-regular fa-arrow-left ms-2"></i> ย้อนกลับ
                      </router-link>
                    </div>
                    <div class="col">
                      <button class="btn btn-primary btn-block" @click="onSubmit" :disabled="checkPassword">
                        ถัดไป <i class="fa-icon fa-regular fa-arrow-right ms-2"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { submitNewPasswordService } from '@/services'
import { isEmpty } from '@/utils/'
export default {
  data () {
    return {
      password: '',
      password_confirm: '',
      profileSelect: ''
    }
  },
  computed: {
    ...mapState({
      profileID: state => state.userModule.profileID,
      profileName: state => state.userModule.profileName,
      UsernameList: state => state.userModule.usernameList
    }),
    checkPassword () {
      return isEmpty(this.password) || isEmpty(this.password_confirm)
    }
  },
  mounted () {
    // alert('test')
  },
  methods: {
    ...mapActions(['setLoading']),
    async onSubmit () {
      try {
        if (this.profileSelect === '') {
          alert('กรุณารเลือก Username')
        }
        this.setLoading(true)
        const resp = await submitNewPasswordService({
          profileID: this.profileSelect,
          password: this.password,
          password_confirm: this.password_confirm
        })
        if (resp.status_code === 'SUCCESS') {
          this.$router.replace('/member/home')
        } else {
          this.password = ''
          this.password_confirm = ''
        }
        this.setLoading(false)
      } catch (error) {
        this.password = ''
        this.password_confirm = ''
        this.setLoading(false)
      }
    },
    async onTest () {
      // console.log(this.UsernameList[0].profileID)
      // console.log(this.profileSelect)
      // console.log(this.password)
      // console.log(this.password_confirm)
    },
    clickProcess (val, id) {
      this.profileSelect = val
    }
  }
}
</script>

<style>
.input-hidden {
  position: absolute;
  left: -9999px;
}

input[type="radio"]+label {
  margin-bottom: 15px !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.w-100 {
  width: 100% !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.border-dark {
  border-color: #0c79e7 !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.w-100 {
  width: 100% !important;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

input[type="radio"]+label>span.badge {
  margin: 0 5px 5px 5px;
}

input[type="radio"]+label>span {
  font-weight: normal;
  text-align: center;
  margin: 0 5px;
  font-weight: normal;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: all 0.3s;
}

.badge-dark {
  color: #fff;
  background-color: #095fb5;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.badge {
  font-size: 0.8rem !important;
}

input[type="radio"]:checked+label::after {
  content: "\f058";
  font-family: "Font Awesome 5 Pro";
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: -20px;
  margin-left: -5px;
  color: #52a4f5;
  background: white;
  padding: 1px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  line-height: 1;
  font-weight: bold;
  font-size: 16px;
  border: #095fb5 2px solid;
  text-align: center;
}

input[type="radio"]:checked+label {
  background: #52a4f5;
  color: white;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>
